import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/manager';

const find = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/reservationAgreements`, {
		branchId,
	});
};

const update = (merchantId, branchId, content, operateBy) => {
	return Client.post(`${baseUrl}/${merchantId}/reservationAgreements`, {
		branchId,
		content,
		operateBy,
		stopFlag: 0,
	});
};

export default {
	find,
	update,
};
